// NotFoundState.jsx
// Not found state component for ListingDetails

import React from 'react';
import { styles } from './styles';

const NotFoundState = () => {
  return (
    <div style={styles.notFoundContainer}>
      <p>Listing not found.</p>
    </div>
  );
};

export default NotFoundState;